<script>
import bem from '@/utils/bem';
import { mapActions } from 'vuex';

const b = bem('change-user-password-modal');
export default {
  data() {
    return {
      open: false,
    };
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
    offset: {
      type: Number,
      required: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      changePasswordAction: 'users/changePassword',
    }),
    showModal() {
      this.open = true;
    },
    handleOk(values) {
      this.changePasswordAction({
        user: {
          password: values.password,
          userId: this.userId,
        },
      });
      this.open = false;
    },
  },
};
</script>

<template>
  <div>
    <a-button type="primary" @click="showModal">Change password</a-button>
    <a-modal v-model:open="open" :footer="null" >
      <FormKit
          type="form"
          submit-label="Save"
          @submit="handleOk"
      >
        <h1 class="text-2xl font-bold mb-2">Change account password</h1>
        <FormKit
            type="text"
            name="password"
            label="Password"
            validation="required|length:6|matches:/[^a-zA-Z]/"
            :validation-messages="{
               matches: 'Please include at least one symbol',
             }"
            placeholder="Your password"
            help="Choose a password"
        />
        <FormKit
            type="text"
            name="password_confirm"
            label="Confirm password"
            placeholder="Confirm password"
            validation="required|confirm"
            help="Confirm your password"
        />
      </FormKit>
    </a-modal>
  </div>
</template>
